import { createSlice } from '@reduxjs/toolkit';

const disc = createSlice({
  name: 'answers',
  initialState: {},
  reducers: {
    saveAnswer: (state, action) => {
      const { question, answer } = action.payload;
      state[question] = answer;
    },
    resetAnswers: () => ({}),
  },
});

export const { saveAnswer, resetAnswers } = disc.actions;
export default disc.reducer;
